import React from "react";
import BlockUi from "react-block-ui";

export default function ServiceCard({
  isLoading,
  data,
  serviceName,
  icon,
  iconBgColor,
  statusMap,
  onCancel,
  isCancellable,
  onReactivate,
  isReactivatable,
  onUpgrade,
  isUpgradable,
  userId,
  headerFields,
  renewalDateField,
  extraFields
}) {
  const currentStatus = data?.cancellation?.cancelled_at
    ? "CANCELLED"
    : data?.configuration?.status;

  const status = statusMap[currentStatus] || Object.values(statusMap)[0];

  if (data?._error) {
    return (
      <div className="col-xl-6 col-lg-6 col-md-12 mb-5">
        <BlockUi tag="div" blocking={isLoading} style={{ height: "100%" }}>
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              border: "1px solid #FFE2E5",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center"
            }}
          >
            <div style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "#FFE2E5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 16
            }}>
              <i className="fas fa-exclamation-triangle" style={{ fontSize: 24, color: "#F64E60" }}></i>
            </div>
            <h3 style={{ color: "#F64E60", marginBottom: 8 }}>Erro ao buscar dados</h3>
            <p style={{ color: "#B5B5C3", fontSize: 14, margin: 0 }}>
              Não foi possível carregar os dados do {serviceName}. Tente novamente mais tarde.
            </p>
          </div>
        </BlockUi>
      </div>
    );
  }

  if (data?._notFound) {
    return (
      <div className="col-xl-6 col-lg-6 col-md-12 mb-5">
        <BlockUi tag="div" blocking={isLoading} style={{ height: "100%" }}>
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              border: "1px solid #E4E6EF",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center"
            }}
          >
            <div style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "#F3F6F9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 16
            }}>
              <i className={icon} style={{ fontSize: 24, color: "#B5B5C3" }}></i>
            </div>
            <h3 style={{ color: "#464E5F", marginBottom: 8 }}>{serviceName}</h3>
            <p style={{ color: "#B5B5C3", fontSize: 14, margin: 0 }}>
              Este cliente não possui configurações de {serviceName}.
            </p>
          </div>
        </BlockUi>
      </div>
    );
  }

  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-5">
      <BlockUi tag="div" blocking={isLoading} style={{ height: "100%" }}>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "10px",
            border: "1px solid #eaeaea",
            height: "100%"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
            <div
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "10px",
                backgroundColor: iconBgColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "15px"
              }}
            >
              <i className={icon} style={{ fontSize: "28px", color: "#fff" }}></i>
            </div>
            <div>
              <h2 className="azul-cabecalho" style={{ lineHeight: 1, marginBottom: "5px" }}>
                {serviceName}
              </h2>
            </div>
          </div>

          {headerFields && headerFields.map((field, index) => (
            <p key={index} style={{ opacity: "0.7", marginBottom: "15px", fontSize: "14px" }}>
              {field}
            </p>
          ))}

          <div style={{ marginTop: "20px" }}>
            <p className="tipo-campo">STATUS</p>
            <p className="campo" style={{ color: status.color, fontWeight: "bold" }}>
              <i className={`${status.icon} mr-2`} style={{ color: status.color }}></i>
              {status.label}
            </p>
          </div>

          {extraFields}

          {!data?.cancellation?.cancelled_at && (
            <>
              <div style={{ marginTop: "15px" }}>
                <p className="tipo-campo">Data de renovação</p>
                <p className="campo">
                  {renewalDateField
                    ? new Date(renewalDateField).toLocaleDateString("pt-BR")
                    : "—"}
                </p>
              </div>
            </>
          )}

          <div style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px"
          }}>
            {onUpgrade && isUpgradable && (
              <button
                type="button"
                className="btn"
                onClick={() => onUpgrade?.()}
                style={{
                  width: "50%",
                  backgroundColor: isUpgradable ? "#E8FFF3" : "#F3F6F9",
                  color: isUpgradable ? "#01AB7D" : "#B5B5C3",
                  border: isUpgradable ? "1px solid #01AB7D" : "1px solid #E4E6EF",
                  fontWeight: "bold",
                  transition: "all 0.2s ease",
                  cursor: isUpgradable ? "pointer" : "not-allowed",
                  opacity: isUpgradable ? 1 : 0.6
                }}
                onMouseEnter={e => {
                  if (isUpgradable) {
                    e.currentTarget.style.backgroundColor = "#01AB7D";
                    e.currentTarget.style.color = "#fff";
                  }
                }}
                onMouseLeave={e => {
                  if (isUpgradable) {
                    e.currentTarget.style.backgroundColor = "#E8FFF3";
                    e.currentTarget.style.color = "#01AB7D";
                  }
                }}
              >
                <i className="fas fa-arrow-up mr-2" />
                Fazer upgrade
              </button>
            )}

            {/* Botão de Reativação - sempre visível, desabilitado quando não é possível reativar */}
            <button
              type="button"
              className="btn"
              disabled={!isReactivatable}
              onClick={() => isReactivatable && onReactivate?.()}
              style={{
                width: "50%",
                backgroundColor: isReactivatable ? "#E1F0FF" : "#F3F6F9",
                color: isReactivatable ? "#3699FF" : "#B5B5C3",
                border: isReactivatable ? "1px solid #3699FF" : "1px solid #E4E6EF",
                fontWeight: "bold",
                transition: "all 0.2s ease",
                cursor: isReactivatable ? "pointer" : "not-allowed",
                opacity: isReactivatable ? 1 : 0.6
              }}
              onMouseEnter={e => {
                if (isReactivatable) {
                  e.currentTarget.style.backgroundColor = "#3699FF";
                  e.currentTarget.style.color = "#fff";
                }
              }}
              onMouseLeave={e => {
                if (isReactivatable) {
                  e.currentTarget.style.backgroundColor = "#E1F0FF";
                  e.currentTarget.style.color = "#3699FF";
                }
              }}
            >
              Reativar
            </button>

            {/* Botão de Cancelamento */}
            <button
              type="button"
              className="btn"
              disabled={!isCancellable}
              onClick={() => onCancel(userId)}
              style={{
                width: onReactivate ? "50%" : "50%",
                backgroundColor: isCancellable ? "#FFF5F5" : "#F3F6F9",
                color: isCancellable ? "#F64E60" : "#B5B5C3",
                border: isCancellable ? "1px solid #F64E60" : "1px solid #E4E6EF",
                fontWeight: "bold",
                transition: "all 0.2s ease",
                cursor: isCancellable ? "pointer" : "not-allowed",
                opacity: isCancellable ? 1 : 0.6
              }}
              onMouseEnter={e => {
                if (isCancellable) {
                  e.currentTarget.style.backgroundColor = "#F64E60";
                  e.currentTarget.style.color = "#fff";
                }
              }}
              onMouseLeave={e => {
                if (isCancellable) {
                  e.currentTarget.style.backgroundColor = "#FFF5F5";
                  e.currentTarget.style.color = "#F64E60";
                }
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      </BlockUi>
    </div>
  );
}

